// extracted by mini-css-extract-plugin
export default {"aboutUsContainer":"CareersLayout_aboutUsContainer__fINIa"};